import { DoubleLeftOutlined } from "@ant-design/icons"
import { Col, Menu, Row } from "antd"
import { useState, useMemo, useEffect } from "react"
import { useNavigate, useLocation } from "react-router-dom"
import { UserMenuStyled } from "../LayoutUser/styled"

const LayoutAdmin = ({ children, menuAdmin }) => {
  const navigate = useNavigate()
  const location = useLocation()
  const [collapseMenu, setCollapseMenu] = useState(false)
  const [themeDark, setThemeDark] = useState(false)
  const [openKeys, setOpenKeys] = useState([])

  // Tính toán active key dựa trên location hiện tại
  const activeKey = useMemo(() => {
    // Giả sử key của menu item khớp chính xác với pathname,
    // hoặc nếu có route con, bạn có thể điều chỉnh điều kiện cho phù hợp.
    return [location.pathname]
  }, [location.pathname])

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth < 1200) {
        setCollapseMenu(true)
      } else {
        setCollapseMenu(false)
      }
    }

    handleResize() // kiểm tra ngay khi mount
    window.addEventListener("resize", handleResize)
    return () => window.removeEventListener("resize", handleResize)
  }, [])

  // Nếu cần, tính toán các openKeys cho menu con
  useEffect(() => {
    const findParentKeys = (items, key) => {
      let keys = []
      for (let item of items) {
        if (item.children) {
          const childKeys = item.children.map(child => child.key)
          if (childKeys.includes(key)) {
            keys.push(item.key)
          }
          keys = keys.concat(findParentKeys(item.children, key))
        }
      }
      return keys
    }

    if (activeKey && activeKey.length > 0) {
      const parentKeys = findParentKeys(menuAdmin, activeKey[0])
      setOpenKeys(prevKeys => Array.from(new Set([...prevKeys, ...parentKeys])))
    }
  }, [menuAdmin, activeKey])

  const onOpenChange = keys => {
    setOpenKeys(keys)
  }

  const onChange = menu => {
    // Giả sử key của menu item đã khớp với route cần navigate
    navigate(menu.key.replace("submenu", ""))
  }

  return (
    <Row gutter={20} style={{ flexWrap: "nowrap", width: "100%" }}>
      <Col style={{ marginLeft: -20 }}>
        <UserMenuStyled
          themeDark={themeDark}
          collapseMenu={collapseMenu}
          style={{ height: "calc(100vh - 77px)" }}
        >
          <div className="side-bar-wrapper">
            <div
              className="menu-scroll-area"
              style={{ overflowY: collapseMenu ? "unset" : "scroll" }}
            >
              <Menu
                onClick={onChange}
                selectedKeys={activeKey}
                mode="inline"
                onOpenChange={onOpenChange}
                openKeys={openKeys}
                items={menuAdmin}
                className="menu-antd-user pt-5"
                theme={themeDark ? "dark" : "light"}
                inlineCollapsed={collapseMenu}
              />
            </div>
            <div
              className="collapsed-item"
              onClick={() => setCollapseMenu(!collapseMenu)}
            >
              <div className="collapsed-icon">
                <DoubleLeftOutlined rotate={collapseMenu ? 180 : 0} />
              </div>
              <div className="collapsed-title">Thu gọn</div>
            </div>
          </div>
        </UserMenuStyled>
      </Col>
      <Col
        className="right-box"
        style={{
          width: "100%",
          height: "calc(100vh - 75px)", // trừ height header
          overflow: "auto",
        }}
      >
        {children}
      </Col>
    </Row>
  )
}

export default LayoutAdmin
